import { render, staticRenderFns } from "./close_button.vue.js?vue&type=template&id=511d2285!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./close_button.vue?vue&type=template&id=511d2285"
import script from "./close_button.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./close_button.vue?vue&type=script&lang=js"
export * from "./close_button.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./close_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports